import { Component } from '@angular/core';
import {MatButton} from '@angular/material/button';
import {scrollToContactSection} from '../../../../utils/helper';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-cover',
  imports: [
    MatButton,
    TranslateModule
  ],
  templateUrl: './cover.component.html',
  styleUrl: './cover.component.scss'
})
export class CoverComponent {

  public onContactClicked() {
    scrollToContactSection();
  }
}
